import React from "react";
import type { PublicDocumentDto } from "../types";

interface PublicDocumentListProps {
  documents: PublicDocumentDto[];
  showTitle?: boolean;
}

function getFileIconClass(doc: PublicDocumentDto): string {
  const name = (doc.displayName ?? doc.fileName ?? "").toLowerCase();
  const mime = (doc.mimeType ?? "").toLowerCase();

  if (name.endsWith(".pdf") || mime.includes("pdf")) {
    return "fas fa-file-pdf text-danger";
  }
  return "fa fa-file-o text-primary";
}

const PublicDocumentList: React.FC<PublicDocumentListProps> = ({
  documents,
  showTitle = false
}) => {
  return (
    <div>
      {showTitle && <h2 className="font-bold m-t-none">Documents</h2>}
      <ul className="list-group bg-white break-word">
        {documents.map((doc) => {
          const linkText = doc.displayName ?? doc.fileName;
          const hasValidUrl = !!doc.downloadUrl;

          return (
            <li key={doc.id} className="list-group-item p-0">
              {hasValidUrl ? (
                <a
                  className="block list-group-item b-none"
                  href={doc.downloadUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="public-document-link"
                  data-document-name={linkText}
                  // WCAG 2.4.4 (Link Purpose): lead with a "Download" verb so the link is
                  // self-describing in a screen reader's links list, and name the new tab.
                  // Mirrors the server-rendered list this replaces (PR 7682, AB#10299).
                  aria-label={`Download ${linkText} (opens in a new tab)`}
                >
                  <i
                    className={`${getFileIconClass(doc)} m-r-xs`}
                    aria-hidden="true"
                  ></i>
                  <span>{linkText}</span>
                </a>
              ) : (
                <span className="text-muted" aria-disabled="true">
                  <i
                    className={`${getFileIconClass(doc)} m-r-xs`}
                    aria-hidden="true"
                  ></i>
                  <span>{linkText} (unavailable)</span>
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PublicDocumentList;
